export const tableData=[
    {
        class2:"odd",
        img:"product-table-1.png",
        title:"Red Shirt",
        detail:"Wild West - Red Cotton Blend Regular Fit Men's Formal Shirt.",
        price:"$10",
        stock:"In Stock",
        class:"font-success",
        date:"2011/04/25",
        btn1:"Delete",
        color1:"danger",
        btn2:"Edit",
        color2:"success"
    },
    {
        class2:"even",
        img:"product-table-2.png",
        title:"blue Shirt",
        detail:"Vida Loca - Blue Denim Fit Men's Casual Shirt.",
        price:"$10",
        stock:"Low Stock",
        class:"font-primary",
        date:"2011/04/25",
        btn1:"Delete",
        color1:"danger",
        btn2:"Edit",
        color2:"success"
    },
    {
        class2:"odd",
        img:"product-table-3.png",
        title:"Men Solid Denim Jacket",
        detail:"The Dry State - Blue Denim Regular Fit Men's Denim Jacket.",
        price:"$10",
        stock:"out of stock",
        class:"font-danger",
        date:"2011/04/25",
        btn1:"Delete",
        color1:"danger",
        btn2:"Edit",
        color2:"success"
    },
    {
        class2:"even",
        img:"product-table-4.png",
        title:"Cyclamen",
        detail:"Stylish co-ord Set 2 piece dress for women",
        price:"$10",
        stock:"Low Stock",
        class:"font-primary",
        date:"2011/04/25",
        btn1:"Delete",
        color1:"danger",
        btn2:"Edit",
        color2:"success"
    },
    {
        class2:"odd",
        img:"product-table-5.png",
        title:"Women shorts",
        detail:"Women Shorts Set",
        price:"$10",
        stock:"In Stock",
        class:"font-success",
        date:"2011/04/25",
        btn1:"Delete",
        color1:"danger",
        btn2:"Edit",
        color2:"success"
    },
    {
        class2:"even",
        img:"product-table-6.png",
        title:"Women Top",
        detail:"Women's Top",
        price:"$10",
        stock:"Low Stock",
        class:"font-primary",
        date:"2011/04/25",
        btn1:"Delete",
        color1:"danger",
        btn2:"Edit",
        color2:"success"
    },
    {
        class2:"odd",
        img:"product-table-1.png",
        title:"Red Shirt",
        detail:"Wild West - Red Cotton Blend Regular Fit Men's Formal Shirt.",
        price:"$10",
        stock:"out of Stock",
        class:"font-danger",
        date:"2011/04/25",
        btn1:"Delete",
        color1:"danger",
        btn2:"Edit",
        color2:"success"
    },
    {
        class2:"even",
        img:"product-table-2.png",
        title:"Blue Shirt",
        detail:"Vida Loca - Blue Denim Fit Men's Casual Shirt.",
        price:"$10",
        stock:"out of Stock",
        class:"font-danger",
        date:"2011/04/25",
        btn1:"Delete",
        color1:"danger",
        btn2:"Edit",
        color2:"success"
    },
    {
        class2:"odd",
        img:"product-table-3.png",
        title:"Men Solid Denim Jacket",
        detail:"The Dry State - Blue Denim Regular Fit Men's Denim Jacket.",
        price:"$10",
        stock:"In Stock",
        class:"font-success",
        date:"2011/04/25",
        btn1:"Delete",
        color1:"danger",
        btn2:"Edit",
        color2:"success"
    },
    {
        class2:"even",
        img:"product-table-4.png",
        title:"Cyclamen",
        detail:"Stylish co-ord Set 2 piece dress for women",
        price:"$10",
        stock:"out of Stock",
        class:"font-danger",
        date:"2011/04/25",
        btn1:"Delete",
        color1:"danger",
        btn2:"Edit",
        color2:"success"
    }
]